module.exports = __webpack_public_path__ + "img/kevin.822ff610.svg";